import { type NodeTypes } from '@xyflow/react';

import { nodeTypes } from '../constants/nodeTypes';

/**
 * Hook to get React Flow node types
 * Returns static reference since node types don't change at runtime
 */
export const useNodeTypes = (): NodeTypes => {
  return nodeTypes;
};
